import { render, staticRenderFns } from "./OrderListGoodsAll.vue?vue&type=template&id=82aade84&scoped=true"
import script from "./OrderListGoodsAll.vue?vue&type=script&lang=js"
export * from "./OrderListGoodsAll.vue?vue&type=script&lang=js"
import style0 from "./OrderListGoodsAll.vue?vue&type=style&index=0&id=82aade84&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82aade84",
  null
  
)

export default component.exports